import { render } from "./Uploader.vue?vue&type=template&id=735efa4a"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"

import "./Uploader.vue?vue&type=style&index=0&id=735efa4a&lang=css"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__